import styled from "styled-components";
import React from "react";
import {Flex, FlexColumnCenter, FlexMinHeightContent, FlexAutoScroll} from "./StyleComponents";
import {
    Button,
    TextField
} from "@material-ui/core";
import {inject, observer} from "mobx-react";
import {Formik} from "formik";
import {debounce} from "ts-debounce";
import sendingSchema from "../validation-schemas/sending-schema";
import {action, observable} from "mobx";
import {withSnackbar} from "notistack";
import SendingToListModal from "./SendingToListModal";
import getConfigSchema from "../validation-schemas/config-schema";
import i18n from "i18next";

const SendingFormWrapperStyled = styled.section`
        width: 700px;
    margin: 0 auto;
    display: block;
    border-radius: 3px;
    /* box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12); */
    background: white;
    //border: 1px solid #eeeeee;
    
    h1{
        margin: 0;
    padding: 19px 15px 10px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    }
    h3{
    margin-top: 0;
    font-weight: 500;
    text-align: center;
    color: rgba(0,0,0,.54);
    margin-bottom: 53px;
    font-size: 16px;
    }
    
    h4{
      font-size: 19px;
      font-weight: 500;
      text-align: ${(props: any) => props.uiStore.isRTL ? 'right' : 'left'};
    }
    
    form{
         padding:  0 40px 40px;
    }
    
    button{
        margin-top: 20px;
        height: 36px;
        margin-left: ${(props: any) => props.uiStore.isRTL ? '0' : '16px'};
        margin-right: ${(props: any) => props.uiStore.isRTL ? '16px' : '0'};
    }
`;
const SendToAllWrapper = styled.div`
  opacity: ${(props: any) => props.disableSendToAll ? '0.3' : '1'};
  text-align: ${(props: any) => props.uiStore.isRTL ? 'right' : 'left'};
`;
const UlStyled = styled.ul`
    list-style: decimal;
    text-align: ${({uiStore}: any) => uiStore.textAlign};
    color: #ff5c5c;
    padding: 0 61px 0;
    a{
    color: black;
    }
`;

@inject("templateStore", "campaignStore", "uiStore", 'api')
@observer
class Sending extends React.Component<any, any> {

    @observable loading: boolean = false;

    @observable isOpenModal: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            emails: [],
        }
    }

    onUpdate = async (field: string, value: any, setFieldTouched: any) => {
        this.setState({[field]: value});
        setFieldTouched(field, true, true);
    };

    onUpdateDebounced = debounce(this.onUpdate, 400);

    onChange = async (event: any, setFieldValue: any, setFieldTouched: any, debounce = true) => {
        let {name, value} = event.target;

        value = value.split(',').map(Function.prototype.call, String.prototype.trim);

        setFieldValue(name, value);

        if (debounce) {
            event.persist();
            this.onUpdateDebounced(name, value, setFieldTouched);
        }
    };

    setFieldTouched = (event: any, setFieldTouched: any) => {
        const {name} = event.target;
        setFieldTouched(name, true, true);
    };

    @action sendTest = async (emails: []) => {
        this.loading = true;

        try {
            const response = await this.props.campaignStore.campaign.sendTest(emails);

            if (response.data.success_send_test) {
                const sendingSuccessfully = this.props.enqueueSnackbar('Has been sent successfully, please check your inbox!', {variant: 'success'});
                setTimeout(() => this.props.closeSnackbar(sendingSuccessfully), 2500);
            } else {
                const errorKey = this.props.enqueueSnackbar(response.data.send_test_response.detail, {variant: 'error'});
                setTimeout(() => this.props.closeSnackbar(errorKey), 3000);
            }

            this.props.campaignStore.campaign.updateFromJson(response.data.campaign);

        } catch (e) {
            console.log(e);
        }

        this.loading = false;
    };

    send = async () => {
        try {
            const response = await this.props.campaignStore.campaign.send();

            this.handleClose();

            if (response.data.error) {
                const errorKey = this.props.enqueueSnackbar(response.data.error, {variant: 'error'});
                setTimeout(() => this.props.closeSnackbar(errorKey), 5000);
            } else {
                const sendingSuccessfully = this.props.enqueueSnackbar('Hooray, campaign has been sent successfully!', {variant: 'success'});
                setTimeout(() => this.props.closeSnackbar(sendingSuccessfully), 2500);
            }
        } catch (e) {
            console.log(e);
        }
    }

    handleClose = () => {
        this.isOpenModal = false;
    }

    handleOpen = () => {
        this.isOpenModal = true;
    }

    canSendTest = () => {
        const errors: any = {};
        const configFormIsValid = getConfigSchema().isValidSync({
            ...this.props.campaignStore.campaign.asJson,
            templateId: this.props.campaignStore.campaign.template ? this.props.campaignStore.campaign.template.id : '',
        });

        if (!configFormIsValid) {
            errors.configFormIsValid = true;
        }

        if (!this.props.api.mailchimpConfig.private_key || this.props.api.mailchimpConfig.private_key === '') {
            errors.privateKeyMissing = true;
        }

        return errors;

    };

    goToConfigForm = (event: any) => {
        this.props.uiStore.setStep(1);
        event.preventDefault();
    };

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        const {
            templateStore,
            campaignStore,
            uiStore,
            api,
            step,
            ...otherProps
        } = this.props;

        const disableSendToAll = (typeof campaignStore.campaign.mailchimpCampaignId === 'undefined' || campaignStore.campaign.mailchimpCampaignId === '' || campaignStore.campaign.mailchimpCampaignId === null);
        const propsDisableSendToAll = {disableSendToAll,uiStore};
        const canSendTest = this.canSendTest();
        const disableSendTest = !!Object.entries(canSendTest).length;
        const errorsMessages = Object.entries(canSendTest).length ? (
            <UlStyled {...this.props}>
                {canSendTest.configFormIsValid ?
                    <li>{i18n.t('A few fields missing in config step, please')} <a href='#2'
                                                                                   onClick={this.goToConfigForm}>
                        {i18n.t('back to')}</a>{i18n.t('complete them')} </li> : null}
                {canSendTest.privateKeyMissing ?
                    <li>{i18n.t('You forget add private key from mailchimp, please')} <a
                        href='/wp-admin/edit.php?post_type=wpex-campaigns&page=wpex_campaigns_settings' target='_blank'>
                        {i18n.t('back to')}</a> {i18n.t('fill before you continue')}</li> : null}
            </UlStyled>
        ) : null;


        return (
            <FlexMinHeightContent {...otherProps} dir={this.props.uiStore.dir}>
                <FlexColumnCenter>
                        <SendingFormWrapperStyled {...this.props} style={{alignItems: 'center'}}>
                            <h1>{disableSendTest ? i18n.t('Ohhh no') : i18n.t('Hooray! All set')}.</h1>
                            <h3>{disableSendTest ? i18n.t('You missed a few things before you could send a test') : i18n.t('Test it, before you spread the news')}</h3>
                            <span style={{display: 'none'}}>
                                {this.loading}
                            </span>

                            {errorsMessages}

                            <Formik
                                initialValues={this.state}
                                validationSchema={sendingSchema}
                                validateOnChange={false}
                                enableReinitialize={true}
                                onSubmit={(values, {setSubmitting}) => {
                                }}
                            >
                                {({
                                      errors,
                                      touched,
                                      values,
                                      setFieldValue,
                                      setFieldTouched,
                                  }: any) => (
                                    <form style={{textAlign: 'left'}}>
                                        <div style={{
                                            display: 'flex',
                                            borderBottom: '1px solid #f0ecec',
                                            paddingBottom: '18px'
                                        }}>
                                            <TextField
                                                style={{flex: 1}}
                                                disabled={this.loading || disableSendTest}
                                                label={i18n.t("Address for test")}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                name='emails'
                                                helperText={touched.emails && errors.emails ? i18n.t('Invalid email pattern') : i18n.t('Fro multiple address separate with comma separator like')}
                                                error={touched.emails && errors.emails && !!errors.emails}
                                                value={values.emails.join(',')}
                                                onChange={(event: any) => this.onChange(event, setFieldValue, setFieldTouched)}
                                                onBlur={(event: any) => this.setFieldTouched(event, setFieldTouched)}
                                            />
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="medium"
                                                disabled={this.loading || Object.entries(touched).length === 0 || (Object.entries(touched).length > 0 && Object.entries(errors).length > 0)}
                                                onClick={() => this.sendTest(this.state.emails)}>
                                                {this.loading && (
                                                    <img
                                                        alt='loading'
                                                        src={process.env.NODE_ENV !== 'production'?'/images/Dual_Ring-1s-200px-blue.svg':'/wp-content/plugins/wp-campaigns/admin/partials/build/images/Dual_Ring-1s-200px-blue.svg'}
                                                        width="20px"
                                                        height="20px" style={{marginRight: 10}}/>)}
                                                {this.loading ? i18n.t('Sending ...') : i18n.t('Test it!') }
                                            </Button>
                                        </div>

                                        <SendToAllWrapper {...propsDisableSendToAll}>
                                            <h4 style={{marginBottom: 0}}>
                                                {i18n.t("Test completed successfully! let's spread the news")}.
                                            </h4>
                                            <Button variant="contained"
                                                    color="primary"
                                                    disabled={disableSendToAll}
                                                    onClick={this.handleOpen}
                                            >
                                                {i18n.t("Send to list")}
                                            </Button>

                                        </SendToAllWrapper>
                                    </form>)}
                            </Formik>
                        </SendingFormWrapperStyled>

                        <SendingToListModal
                            handleClose={this.handleClose}
                            isOpenModal={this.isOpenModal}
                            action={this.send}
                        />
                </FlexColumnCenter>
            </FlexMinHeightContent>
        );
    }
}

export default withSnackbar(Sending);
